import type { ErrorEvent, EventHint } from '@sentry/react'
import addAxiosErrorContextRecursive from './addAxiosErrorContext'

export const beforeSend = (event: ErrorEvent, hint: EventHint) => {
  addAxiosErrorContextRecursive(event, hint?.originalException)
  return event
}
